export default {
      id: "color_tube_blue-usage",
      viewBox: "0 0 130 211.9",
      url: __webpack_public_path__ + "sprite.svg#color_tube_blue",
      toString: function () {
        return this.url;
      }
    }